import { Suspense } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "./hooks/useAuth.tsx";
import { SearchProvider } from "./hooks/useSearch";
import i18n from "./i18n";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <SearchProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <Suspense fallback={
              <div className="flex h-screen w-screen bg-gray-50">
                <aside className="h-full w-64 shrink-0 bg-gradient-to-b from-emerald-600 to-emerald-700" />
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="h-16 border-b border-gray-200 bg-white" />
                  <div className="flex flex-1 items-center justify-center">
                    <div className="flex flex-col items-center gap-4">
                      <div className="h-12 w-12 animate-spin rounded-full border-4 border-emerald-500 border-t-transparent" />
                      <p className="animate-pulse text-sm font-medium text-gray-500">正在加载页面...</p>
                    </div>
                  </div>
                </div>
              </div>
            }>
              <AppRoutes />
            </Suspense>
          </BrowserRouter>
        </SearchProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
